import { IconAlertTriangleFilled } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@cfa/react-components';

import { AssignableCourseResult } from '@/_generated/api-clients/xp';

interface CompleteStatusProps {
  complianceStatus: AssignableCourseResult | undefined;
  totalTeamMembers: number;
  completedUsers: number;
  isEnabled: boolean;
}

const CompleteStatus: React.FC<CompleteStatusProps> = ({
  complianceStatus,
  totalTeamMembers,
  completedUsers,
  isEnabled,
}) => {
  const { t } = useTranslation();

  if (!complianceStatus?.enrollments) {
    return t('Generic.loading');
  }

  if (!totalTeamMembers) {
    return t('Generic.noTeamMembersAssigned');
  }

  return (
    <span className="flex items-center">
      {isEnabled && (
        <Tooltip
          content={t('TrainingPlans.accountability.outOfCompliance')}
          placement="bottom"
        >
          <IconAlertTriangleFilled className="text-feedback-warning-base mr-2 size-4" />
        </Tooltip>
      )}
      {`${completedUsers}/${totalTeamMembers} ${t(
        'Generic.teamMembersCompleted',
      )}`}
    </span>
  );
};

export default CompleteStatus;
